import React from "react";
import './index.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from 'react-dom/client';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import "maplibre-gl/dist/maplibre-gl.css";
import CookiePopup from "./Common/cookiePopup";

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CookiePopup />
    <App />
  </React.StrictMode>,
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
